var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediodia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_523",
    "data-name": "Group 523",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    transform: "translate(5.531 5.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M2.888,0A2.888,2.888,0,1,0,5.776,2.888,2.9,2.9,0,0,0,2.888,0Zm0,4.813A1.925,1.925,0,1,1,4.813,2.888,1.931,1.931,0,0,1,2.888,4.813Z",
    transform: "translate(3.85 3.85)",
    fill: "#eaf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M.481,0A.455.455,0,0,0,0,.481V2.406a.455.455,0,0,0,.481.481.455.455,0,0,0,.481-.481V.481A.455.455,0,0,0,.481,0Z",
    transform: "translate(6.257 10.589)",
    fill: "#eaf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M.481,0A.455.455,0,0,0,0,.481V2.406a.455.455,0,0,0,.481.481.455.455,0,0,0,.481-.481V.481A.455.455,0,0,0,.481,0Z",
    transform: "translate(6.257 0)",
    fill: "#eaf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M1.829,0a.437.437,0,0,0-.337.144L.144,1.492a.465.465,0,0,0,0,.674.465.465,0,0,0,.674,0L2.166.818a.465.465,0,0,0,0-.674A.437.437,0,0,0,1.829,0Z",
    transform: "translate(1.829 9.337)",
    fill: "#eaf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M1.829,0a.437.437,0,0,0-.337.144L.144,1.492a.465.465,0,0,0,0,.674.465.465,0,0,0,.674,0L2.166.818a.465.465,0,0,0,0-.674A.52.52,0,0,0,1.829,0Z",
    transform: "translate(9.337 1.829)",
    fill: "#eaf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M2.406,0H.481A.455.455,0,0,0,0,.481.455.455,0,0,0,.481.963H2.406A.455.455,0,0,0,2.888.481.455.455,0,0,0,2.406,0Z",
    transform: "translate(0 6.257)",
    fill: "#eaf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M2.406,0H.481A.455.455,0,0,0,0,.481.455.455,0,0,0,.481.963H2.406A.455.455,0,0,0,2.888.481.455.455,0,0,0,2.406,0Z",
    transform: "translate(10.589 6.257)",
    fill: "#eaf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M.481,0A.437.437,0,0,0,.144.144a.465.465,0,0,0,0,.674L1.492,2.166a.476.476,0,0,0,.674-.674L.818.144A.437.437,0,0,0,.481,0Z",
    transform: "translate(1.829 1.829)",
    fill: "#eaf5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M.481,0A.437.437,0,0,0,.144.144a.465.465,0,0,0,0,.674L1.492,2.166a.476.476,0,0,0,.674-.674L.818.144A.52.52,0,0,0,.481,0Z",
    transform: "translate(9.337 9.337)",
    fill: "#eaf5ed"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    fill: "none",
    stroke: "#eaf5ed",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediodia);
export default __webpack_public_path__ + "static/media/Mediodia.114f6d4d246d759dcf03d415a990293a.svg";
export { ForwardRef as ReactComponent };